import { LiquidityProvider } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { AddressMap } from '@emberswap/emberswap-sdk2/dist/types/AddressMap'


/**
 *
 */
export abstract class UniswapV2BaseProvider extends LiquidityProvider {
  fee = 0.003
  factory: string
  initCodeHash: string
  /**
   * @param {ChainId}chainId
   * @param {Address}factory
   * @param {string}initCodeHash
   * @param {[Token, Token][]}currencyCombinations
   */
  constructor(chainId: ChainId, factory: AddressMap, initCodeHash: AddressMap) {
    super(chainId)
    this.factory = factory[chainId]
    this.initCodeHash = initCodeHash[chainId]
  }
}
